import { createFileRoute } from "@tanstack/react-router";
import { AppView } from "../../../../components/app/app-view";
import { searchEnum } from "../../../../lib/search";

const PANELS = ["details", "history", "share"] as const;

interface AppSearch {
  /** Open a panel on arrival (e.g. Home ⋯ → Details, "is live" toast → Share). */
  panel?: (typeof PANELS)[number];
}

export const Route = createFileRoute("/_authed/a/$slug/")({
  validateSearch: (search: Record<string, unknown>): AppSearch => {
    const panel = searchEnum(search.panel, PANELS);
    return panel === undefined ? {} : { panel };
  },
  component: AppRoute,
});

function AppRoute() {
  const { slug } = Route.useParams();
  const { panel } = Route.useSearch();
  // Remount per app so panels and frame state reset.
  return <AppView key={slug} slug={slug} initialPanel={panel} />;
}
